// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoInternet_wrapper__oMylo","banner":"NoInternet_banner__3RLWi","picto":"NoInternet_picto__2_cs6"};